export default {
    daily_expense: []

}